import { render, staticRenderFns } from "./BatchPointUploadTool.vue?vue&type=template&id=89d1ef2c&scoped=true&"
import script from "./BatchPointUploadTool.vue?vue&type=script&lang=js&"
export * from "./BatchPointUploadTool.vue?vue&type=script&lang=js&"
import style0 from "./BatchPointUploadTool.vue?vue&type=style&index=0&id=89d1ef2c&prod&lang=scss&scoped=true&"
import style1 from "./BatchPointUploadTool.vue?vue&type=style&index=1&id=89d1ef2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d1ef2c",
  null
  
)

export default component.exports